import {
  MealCalorie,
  MealContent,
  MealName,
  MealNameBox,
  MealTypeTag,
  MealUnitAndPortionBox,
  MealUnitAndPortionText,
  StyledMealItem,
  StyledSwipeAction,
} from "./styled"
import { useEffect, useRef } from "react"
import { formatDisplayNumber, getDisplayCalories } from "utils"
import TrashIcon from "components/Icons/TrashIcon"
import { SwipeActionRef } from "antd-mobile"
import { generatePath, useNavigate } from "react-router-dom"
import { useSetMealDetails } from "features/meal/hooks/mealDetailsHooks"
import PATHS from "router/paths"
import MyFoodIcon from "components/Icons/MyFood"
import dayjs from "dayjs"
import ClockIcon from "components/Icons/ClockIcon"
import { MealType } from "model/food/types"
import { ScheduleBackPage } from "model/food/types/schedule.types"
import { isMyFood } from "model/food/utils/typeGuards/foodTypeGuards"
import { useDeleteMeal } from "features/home/hooks"
import { FlexBox } from "components/Common/FlexBox"
import { formatUnit } from "utils/formater"
import {
  isEdamaMeal,
  isOpenFoodFactMeal,
} from "model/food/utils/typeGuards/mealTypeGuards"
import { FoodBrand } from "components/foodItem/FoodListItem/styled"
import useDisplayFoodBottomLine from "features/food/hooks/useDisplayFoodBottomLine"
import { isFutureDate } from "utils/dateTime"

interface MealItemProps {
  meal: MealType
  swipedId: string | null
  setSwipedId: (id: null | string) => void
}

const DiaryMealItem = (props: MealItemProps) => {
  const { meal, swipedId, setSwipedId } = props
  const isFutureScheduleMeal = !!meal.scheduleId && isFutureDate(meal.createdFor)

  const { handleDeleteMeal } = useDeleteMeal()
  const setMealDetails = useSetMealDetails()

  const navigate = useNavigate()

  const goToUpdateMeal = () => {
    setMealDetails(meal)
    navigate(
      generatePath(PATHS.app.meal.edit, {
        id: meal.id,
      }),
    )
  }

  const onGoToScheduleDetails = (id: string) => {
    navigate(
      generatePath(
        PATHS.app.schedule.details + `?from=${ScheduleBackPage.DIARY}`,
        {
          id,
        },
      ),
    )
  }

  useEffect(() => {
    if (swipedId && swipedId !== meal.id) {
      ref.current?.close()
    }
  }, [swipedId])

  const ref = useRef<SwipeActionRef>(null)

  const brand = isEdamaMeal(meal) || isOpenFoodFactMeal(meal) ? meal.brand : ""

  const {
    containerRef,
    tagRef,
    unitRef,
    brandRef,
    brandMaxWidth,
    unitMaxWidth,
  } = useDisplayFoodBottomLine(brand)

  const mealElement = (
    <StyledMealItem
      $isFutureScheduleMeal={isFutureScheduleMeal}
      onClick={() => {
        goToUpdateMeal()
      }}
    >
      <MealContent
        $isFutureScheduleMeal={isFutureScheduleMeal}
        ref={containerRef}
      >
        <MealNameBox>
          <MealName $isFutureScheduleMeal={isFutureScheduleMeal}>
            {meal.name}
          </MealName>
          {isMyFood(meal) && <MyFoodIcon />}{" "}
        </MealNameBox>

        <FlexBox $gap={4}>
          <FlexBox $alignItems="center" $gap={6}>
            <MealUnitAndPortionBox
              ref={unitRef}
              style={{ maxWidth: unitMaxWidth }}
            >
              <MealUnitAndPortionText>
                {formatDisplayNumber(meal.portion, 2)} {""}
                {formatUnit(meal.unit, isEdamaMeal(meal))}
              </MealUnitAndPortionText>
            </MealUnitAndPortionBox>

            {meal.type && (
              <MealTypeTag ref={tagRef}>
                {meal.type.toLocaleLowerCase()}
              </MealTypeTag>
            )}
          </FlexBox>

          {brand && (
            <FoodBrand ref={brandRef} style={{ maxWidth: brandMaxWidth }}>
              <p> {brand}</p>
            </FoodBrand>
          )}
        </FlexBox>
      </MealContent>

      <MealCalorie $isFutureScheduleMeal={isFutureScheduleMeal}>
        {isFutureScheduleMeal && <ClockIcon />}
        {getDisplayCalories(meal.calorie)} cal
      </MealCalorie>
    </StyledMealItem>
  )

  if (isFutureScheduleMeal) {
    return mealElement
  }

  return (
    <StyledSwipeAction
      closeOnTouchOutside={false}
      ref={ref}
      onActionsReveal={() => {
        setSwipedId(meal.id)
      }}
      closeOnAction={false}
      rightActions={[
        {
          key: "delete",
          text: (
            <TrashIcon
              style={{
                width: 22,
                height: 22,
                marginLeft: 2,
              }}
            />
          ),
          color: "danger",
          onClick: () => {
            handleDeleteMeal(meal.id)
          },
        },
      ]}
    >
      {mealElement}
    </StyledSwipeAction>
  )
}

export default DiaryMealItem
